<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<p style="margin-top:150px;">“Those who forget history are condemned to repeat it.” Sir Winston Churchill and others.</p><br/><br/>
<p style="text-indent:0em;">“Power corrupts: absolute power corrupts absolutely. All powerful men are bad.” Lord Acton</p>
<p style="text-indent:0em;"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?92c064d8